import { useCallback, useLayoutEffect } from 'react';
import { useAppDispatch } from 'src/AppContext';
import { userQRLogin } from 'src/services/api';
import { useUser } from 'src/UserContext';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useLocation } from 'react-router-dom';
import { parse } from 'querystring';
import { useModal } from 'src/ModalContext';
import LoginView from '../View';
import { get } from 'lodash';

export default function LoginQR(): JSX.Element {
  const { t } = useTranslation();
  const location = useLocation();
  const qs = location.search.replace(/^[?]/gi, '');
  const { qrLoginSessionId } = parse(qs);
  const history = useCustomHistory();
  const dispatch = useAppDispatch();
  const { login, logout } = useUser();
  const { showModal } = useModal();

  // 폼 sumit -> ajax 요청으로 대체
  const onSubmit = useCallback(
    async (e) => {
      userQRLogin({
        qrLoginSessionId: qrLoginSessionId as string,
        email: e.target.email.value.trim(),
        password: e.target.password.value,
      })
        .then((res) => {
          login(res);
          history.push('/login/complete');
        })
        .catch((e) => {
          logout();
          const code = get(e, 'response.data.code');
          switch (code) {
            case 'USER_NOT_FOUND':
              showModal({
                message: t('login/login_fail'),
                success: () => {
                  return;
                },
              });
              break;
            case 'NOT_VERIFIED_USER':
              history.push('/email-link', e.response.data.data);
              break;
          }
        });
    },
    [history],
  );

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'back' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_CENTER', isShow: false });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'SET_GNB_CENTER', isShow: true });
    };
  }, []);

  return <LoginView isShowAutoLogin={false} onSubmit={onSubmit} />;
}
